import { CubeIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { Button } from '../../../components/ui/button';
import { SUCCESS_LOGO_PATH } from '../../../constants/logo';
import { formatCurrency } from '../../../utils/fiat-currency.util';

interface PinLimitSuccessPopupProps {
  limit: number;
  currencyCode: string;
  onClose: () => void;
}

const PinLimitSuccessPopup: React.FC<PinLimitSuccessPopupProps> = ({
  limit,
  currencyCode,
  onClose
}) => {
  const featureStatus =
    limit > 0
      ? `PIN required for transactions above ${formatCurrency(limit, currencyCode)}`
      : 'PIN required for all transactions';

  return (
    <div className="p-2">
      <img src={SUCCESS_LOGO_PATH} className="mx-auto h-32" alt="Success" />
      <h2 className="mb-1 mt-2 text-center text-lg font-bold">
        Settings Saved
      </h2>
      <p className="mb-4 text-center text-sm text-gray-500">
        Your transaction limit has been successfully modified and is now active.
      </p>

      <div className="rounded-xl border border-gray-100 bg-gray-50 p-4">
        <div className="flex items-start gap-3 border-b border-gray-200 pb-3">
          <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-orange-100">
            <CubeIcon className="h-5 w-5 text-orange-500" />
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">
              Feature Status
            </p>
            <p className="text-sm font-medium text-gray-900">{featureStatus}</p>
          </div>
        </div>

        <div className="flex items-start gap-3 pt-3">
          <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-orange-100">
            <ShieldCheckIcon className="h-5 w-5 text-orange-500" />
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">
              Transaction Limit
            </p>
            <p className="text-sm font-medium text-gray-900">
              {formatCurrency(limit, currencyCode)}
            </p>
          </div>
        </div>
      </div>

      <Button type="button" className="mt-6 w-full" onClick={onClose}>
        Done
      </Button>
    </div>
  );
};

export default PinLimitSuccessPopup;
